import * as Card from '@/components/ui/card'
import { DataGuard } from '@components/DataGuard'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { useSingle } from '../state'
import { Actions } from './actions/Actions'
import { AdminActions } from './actions/AdminActions'
import ArchivedAlert from './ArchivedAlert'
import Creation from './Creation'
import Crumb from './Crumb'
import Description from './Description'
import Details from './Details'
import Header from './Header'

export default function Single() {
  const { setupQuery } = useService(useSingle)()

  return (
    <Card.Root height={{
      base: '100%',
      xlDown: 'calc(var(--vh) * 100 - 154px)',
      mdDown: 'calc(var(--vh) * 100 - 110px)',
    }}
      gap='14px'
      pt='18px'
      pr='18px'
      pb='20px'
      pl='18px'
      gridAutoRows='max-content'
      class='scrollbar'
      overflowY='auto'>
      <DataGuard
        query={setupQuery}
      >
        {setup => (
          <>
            <Crumb />
            <ArchivedAlert />
            <Header setup={setup} />
            <Creation setup={setup} />
            <Grid gap="6px">
              <AdminActions />
              <Actions />
            </Grid>
            <Details setup={setup} />
            <Description setup={setup} />
          </>
        )}
      </DataGuard>
    </Card.Root>
  )
}

